var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var log = require('./log');

var format = require('./format');

var SpanProcessor =
/*#__PURE__*/
function () {
  "use strict";

  function SpanProcessor(exporter, prioritySampler) {
    _classCallCheck(this, SpanProcessor);

    this._exporter = exporter;
    this._prioritySampler = prioritySampler;
  }

  _createClass(SpanProcessor, [{
    key: "process",
    value: function process(span) {
      var spanContext = span.context();
      var trace = spanContext._trace;

      if (trace.started.length === trace.finished.length) {
        this._prioritySampler.sample(spanContext);

        if (spanContext._traceFlags.sampled === false) {
          log.debug(function () {
            return "Dropping trace due to user configured filtering: ".concat(trace.started);
          });

          this._erase(trace);

          return;
        }

        var formattedSpans = trace.finished.map(format);

        this._exporter.export(formattedSpans);

        this._erase(trace);
      }
    }
  }, {
    key: "_erase",
    value: function _erase(trace) {
      trace.finished.forEach(function (span) {
        span.context()._tags = {};
      });
      trace.started = [];
      trace.finished = [];
    }
  }]);

  return SpanProcessor;
}();

module.exports = SpanProcessor;